import { BaseModel } from './BaseModel';
import { Airsacculitis, S0, E0, D0 } from './Documents';
import { Mortality } from './Batch';

class BatchDivisionPerformanceData extends BaseModel {
  hydrate(data, source) {
    const isApi = source === 'api';

    this.age = data.age;
    this.week = data.week;
    this.weight = data.weight;
    this.adjustedWeight = isApi ? data.adjusted_weight : data.adjustedWeight;
    this.predictWeight = isApi ? data.predict_weight : data.predictWeight;
    this.gain = data.gain;
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}

export class BatchDivision extends BaseModel {
  hydrate(data, source) {
    const isApi = source === 'api';

    this.id = data.id ?? null;
    this.type = data.type ?? null;
    this.identification = data.identification ?? null;

    this.currentLodge = isApi ? data.current_lodge : data.currentLodge ?? null;

    /* ================= PERFORMANCE ================= */

    this.weight = data.weight ?? null;

    this.weekWeight = isApi ? data.week_weight : data.weekWeight ?? null;

    this.weekGain = isApi ? data.week_gain : data.weekGain ?? null;

    this.conversionFactor = isApi ? data.conversion_factor : data.conversionFactor ?? null;

    this.uniformity = data.uniformity ?? null;

    this.samples = Array.isArray(data.samples) ? data.samples : [];

    const performanceData = isApi ? data.performance_data : data.performanceData;
    
    this.performanceData = Array.isArray(performanceData)
    ? performanceData.map((item) => BatchDivisionPerformanceData.create(item, source))
    : [];
    
    /* ================= SANITY ================= */

    const airsacculitisData = isApi ? data.airsacculitis : data.airsacculitis;

    this.airsacculitis = Array.isArray(airsacculitisData)
      ? airsacculitisData.map((item) => Airsacculitis.create(item, source))
      : [];

    const mortalityData = isApi ? data.mortality : data.mortality;

    this.mortality = Array.isArray(mortalityData)
      ? mortalityData.map((item) => Mortality.create(item, source))
      : [];

    const s0Data = isApi ? data.s0 : data.s0;
    this.s0 = Array.isArray(s0Data) ? s0Data.map((item) => S0.create(item, source)) : [];

    const d0Data = isApi ? data.d0 : data.d0;
    this.d0 = Array.isArray(d0Data) ? d0Data.map((item) => D0.create(item, source)) : [];

    const e0Data = isApi ? data.e0 : data.e0;
    this.e0 = Array.isArray(e0Data) ? e0Data.map((item) => E0.create(item, source)) : [];
  }

  static fromApi(data) {
    return this.create(data, 'api');
  }

  static fromStore(data) {
    return this.create(data, 'store');
  }
}
